import axios from 'axios';

// HR Module API Configuration
export const API = process.env.REACT_APP_BACKEND_URL + '/api/hr';

// Get auth token (checks multiple possible storage keys)
export const getAuthToken = () => {
  return localStorage.getItem('authToken') || 
         localStorage.getItem('hrToken') || 
         localStorage.getItem('financeToken') ||
         localStorage.getItem('token');
};

// Configure global axios default to include auth header
axios.interceptors.request.use((config) => {
  // Only add header for our API calls
  if (config.url && (config.url.includes('/api/') || config.url.includes(process.env.REACT_APP_BACKEND_URL))) {
    const token = getAuthToken();
    if (token && !config.headers.Authorization) {
      config.headers.Authorization = `Bearer ${token}`;
    }
  }
  return config;
});

// Create axios instance with auth header
const hrApiClient = axios.create({
  baseURL: API
});

// Add auth interceptor
hrApiClient.interceptors.request.use((config) => {
  const token = getAuthToken();
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Add response interceptor for auth errors
hrApiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('hrToken');
      localStorage.removeItem('authToken');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export default hrApiClient;
